import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract.js'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'

export class MasterBasicTabHP extends TabBookingAbstract {
  constructor(view) {
    super(view)
    this.$t = this.view.$t
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  /**
   * 更新页面显示
   */
  updateView() {
    if (this.job.cargoSource === null || this.job.cargoSource === 'NC') {
      this.view.visibleDesignationAgent = true
      this.view.customerLabel1 = this.view.$t('SeaExport.ActualNotifyParty')
      this.view.customerLabel2 = this.view.$t('SeaExport.ActualNotifyPartyHeader')
    } else {
      this.view.visibleDesignationAgent = false
      this.view.customerLabel1 = this.view.$t('SeaExport.ConsignationCompany')
      this.view.customerLabel2 = this.view.$t('SeaExport.ConsignationCompanyHeader')
    }
    this.view.isTwoVessel = this.job.secondVessel != null && this.job.secondVessel !== ''
  }

  loadCompanyOffice() {
    // todo  此处 officeList 未加载结束
    /* const job = this.job
    const office = this.view.officeList.filter(p => p.officeId === job.salesOffice)[0]
    if (office) {
      this.view.txtSalesOffice = office.chineseName
    } else {
      this.view.txtSalesOffice = ''
    }*/
    this.view.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', this.job.salesOffice, 'chineseName')
  }

  // 加载 客户属性
  async loadCustomerLevel() {
    let company = await Company.getCompanyById(this.job.customerId)
    company = new Company(company)
    let customer = await company.getCustomerDetail()
    if (customer) {
      customer = new Customer(customer)

      const customerType = await customer.getCustomerType()
      if (customerType) {
        this.view.customerLevel.level = customerType.typeId
        this.view.customerLevel.customerName = customerType.chineseName
      }
    }
    const contractState = this.view.contractStatuses[Number(company.contractStatus)]
    this.view.contractStatusLabel = contractState ? contractState.label : ''
    this.view.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.job))
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
      job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.userDefinedRoleOffice1 = office ? office.officeId : 0
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
      job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.userDefinedRoleOffice2 = office ? office.officeId : 0
    }
  }
}
